// removed by extract-text-webpack-plugin
module.exports = {"ChatBubbleWrapper":"_31gQUzrlh6fObLUaUqiU9Z","circleGWrapper":"_1cuD6Aq2nPF9KNwls35HGc","circleG":"iHkcHbgWhURpqWUwATckk","bounce_circleG":"_3PnbkviXFLYPzHIbjwdux_","circleG_1":"_3Cf3qzjo0Y4TeAvGFRaXDI","circleG_2":"_2YWmfcdbm0rthXmUhZYU8d","circleG_3":"_1Wt9Duzn5EbG75GZIqH2T6"};


//////////////////
// WEBPACK FOOTER
// ./src/component/TypingIndicator/ChatBubble/style.css
// module id = 1552
// module chunks = 0